const listeners = new Set();

export const notifyBackendRequestActivity = () => {
  listeners.forEach((listener) => {
    listener();
  });
};

export const subscribeBackendRequestActivity = (listener) => {
  if (typeof listener !== "function") {
    return () => {};
  }

  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};
